<template>
    <div class="pm-smart-animation-item renderfix" style="padding: 8px;">

        <div class="pm-smart-animation-item-image" style="padding-top: Calc((9/16)*100%)" :style="{/*maxHeight: thumbHeight,*/ backgroundImage: 'url(' + thumb + ')'}"></div>

        <!-- <div class="video-thumb-unlock-overlay" :style="{height: thumbHeight}" v-if="!$IAP.hasAccessToComponent('videos')">
            <div style="padding-top: 5px; text-align: center; font-size: 9px; color: #fff!important; font-weight: 600; line-height: 2;" class="gallery--premium-badge">
                <mdi style="color: #fff!important;">lock</mdi><br/>
                PREMIUM
            </div>
        </div> -->

        <div>
            <div class="pm-smart-animation-item--region" v-text="getVideoMeta('region')" />
            <div :class="$theme.baseText" class="pm-smart-animation-item--title" v-html="getVideoMeta('title')" />
            <div :class="$theme.baseText" class="pm-smart-animation-item--subtitle" v-html="getVideoMeta('subtitle') || '&nbsp;'" />
        </div>

    </div>
</template>


<style lang="scss">
    @media (min-width: 700px) {
        .pm-smart-animation-item--title-wrapper {
            height: 3rem !important;
        }
    }

    .pm-smart-animation-item {
        @supports (aspect-ratio: 16 / 9) {
            .pm-smart-animation-item-image {
                aspect-ratio: 16 / 9;
                height: 100%;
            }
        }

        @supports not (aspect-ratio: 16 / 9) {
            .pm-smart-animation-item-image {
                position: relative;
                width: 100%;
                padding-top: 56.25%; /* 16:9 Aspect Ratio (https://web.dev/aspect-ratio/) */
            }
        }

        .pm-smart-animation-item-image {
            border-radius: 3px; box-shadow: 2px 2px 3px rgba(0,0,0,.15);
            max-width: 100%;
            background: #eee;
            background-position: center center;
            background-size: cover;
        }

        .pm-smart-animation-item--region {
            text-transform: uppercase;
            right: 0;
            margin-right: 12px;
            margin-top: -16px;
            display: inline-block;
            background: #a6a7aa;
            border-radius: 3px;
            position: absolute;
            padding: 2px 4px;
            font-size: 8px;
            color: #fff;
            line-height: 1;
        }

        .pm-smart-animation-item--title, .pm-smart-animation-item--subtitle {
            line-height: 1.15;
            max-height: 28px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .pm-smart-animation-item--title {
            font-size: 10px;
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: -0.2px;
            margin-top: 10px;
        }

        .pm-smart-animation-item--subtitle {
            font-size: 10px;
            color: #a6a7aa;
            margin-bottom: 20px;
        }

        .video-thumb-unlock-overlay {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            right: 8px;
            top: 8px;
            left: 8px;
            cursor: pointer;
            background: rgba(150,150,150,.7);
            padding: 3px;
            border-radius: 3px;
        }
    }

    .pm-smart-animation-item:after {
        content: "___";
        position: absolute;
        bottom: 8px;
        left: 0;
        right: 0;
        text-align: center;
        opacity: .25;
    }

@media (min-width: 700px) {
    .gallery--premium-badge {
        font-size: 16px !important;
    }

    .gallery--premium-badge svg {
        width: 40px;
        height: 40px;
    }
}
</style>


<script>
/** @typedef {import('@/types').Video} Video */
import freeIds from "@/components/animations/freeIds";
export default {
    props: {
        item: {
            /** @type {import('vue').PropType<Video>} */
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        freeIds: freeIds,
        thumb: '',
        thumbHeightData: '',
        grid: localStorage.getItem('videosGrid') || 2,
    }),
    computed: {
        thumbHeight() {
            return this.thumbHeightData
        },
        is4in1() {
            return this.$packageName === 'com.denticalc.4in1';
        },
    },
    mounted() {
        this.getThumb();

    },
    created() {
        this.thumbHeightData = this.getThumbHeight();

        window.addEventListener('orientationchange', () => {
            this.thumbHeightData = this.getThumbHeight();
        });

        window.addEventListener("online", () => {
            this.thumb = "";
            this.$nextTick(() => {
                this.getThumb();
                this.$forceUpdate();
            });
        });
    },
    methods: {
        getThumbHeight() {
            try {
                let w = screen.width;
                w-=64;
                return (Math.floor(w/3) / (16/9)) + 'px';
            } catch(error) {
                window.captureException(error);
                return '100px';
            }
        },
        getThumb() {
            this.thumb = 'https://cdn.denticalc.com/videos/' + this.item.video + '.thumb.500.jpg';

            if (this.grid < 2 || document.body.getBoundingClientRect().width > 600) {
                this.thumb = this.thumb.replace('thumb.jpg', 'thumb.500.jpg');
            }
        },

        getVideoMeta(meta = 'title') {
            try {
                const language = this.$store.state.language && this.$store.state.language || 'en';
                if (!this.item.hasOwnProperty(meta)) return '';
                if (this.item[meta].hasOwnProperty(language)) return this.item[meta][language];
                if (this.item[meta].hasOwnProperty('en')) return this.item[meta]['en'];
                return '';
            } catch (e) {
                captureException(e);
                return '';
            }
        },
    },
};
</script>
